<template>
    <div class="flex flex-col sm:flex-row border border-r-0 border-gray-400 bg-white">
        <dashboard-status-tab-small
            color="green"
            text_color="text-green-500"
            border_color="border-green-400"
            :tally="tally.green"
        />

        <dashboard-status-tab-small
            color="yellow"
            text_color="text-yellow-500"
            border_color="border-yellow-500"
            :tally="tally.yellow"
        />

        <dashboard-status-tab-small
            color="red"
            text_color="text-red-600"
            border_color="border-red-600"
            :tally="tally.red"
        />
    </div>
</template>

<script>
import DashboardStatusTabSmall from './dashboard-status-tab-small.vue';

export default {
    components: {
        DashboardStatusTabSmall,
    },

    props: {
        properties: {},
    },

    computed: {
        tally() {
            return {
                green: this.getCountByColor('green'),
                yellow: this.getCountByColor('yellow'),
                red: this.getCountByColor('red'),
            }
        },
    },

    methods: {
        getCountByColor(color) {
            return this.properties.filter(property => property.status.overall == color).length;
        },
    },
}
</script>
